import Marquee from "react-fast-marquee";
import { Diamond } from "@phosphor-icons/react";

const items = ["SEGURANÇA", "CONTINUIDADE", "ORGANIZAÇÃO", "PROATIVIDADE", "CONEXÃO ESTÁVEL"];

export default function EditorialMarquee() {
  return (
    <section className="bg-ink py-6 border-y border-gold/20 noise-overlay" data-testid="editorial-marquee" aria-hidden="true">
      <Marquee speed={35} gradient={false} pauseOnHover={false}>
        {items.map((item) => (
          <span key={item} className="flex items-center gap-8 mx-8">
            <span className="font-display font-extrabold tracking-[0.25em] text-gold text-lg md:text-xl whitespace-nowrap">
              {item}
            </span>
            <Diamond size={12} weight="fill" className="text-gold/50" />
          </span>
        ))}
      </Marquee>
    </section>
  );
}
